import { render, staticRenderFns } from "./ButtonNavigate.vue?vue&type=template&id=304c2f08"
import script from "./ButtonNavigate.vue?vue&type=script&lang=js"
export * from "./ButtonNavigate.vue?vue&type=script&lang=js"
import style0 from "./ButtonNavigate.vue?vue&type=style&index=0&id=304c2f08&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports